<template>
      <form ref="formRef">
      <ed-modal title="Add User" :show="show" @close="$emit('close')" validation @validate='addUser' primary-button="Add" @confirm="addUser" type = "small-medium">
        <div slot="body">
          <div class="add-user-overlay">
            <p class="bold">User Information</p>
            <div class="form-group">
              <label v-if="accountId === ''" for="roles">{{rolesName}}</label>
              <label for="role">User Role *</label>
              <ed-select @input="(o) => { addObjectUser.Role = o; this.roleIncomplete = false; }"
                         placeholder="Select a Role"
                         :options="roles"
                         @open="getUserRoles"
                         v-model="selectRole"
                         label="Name"
                         track-by="Id"
                         :error="roleIncomplete"
                         name="role_user" />
            </div>
            <div class="input-group row">
              <div class="form-group col-md-5">
                <label v-if="accountId === ''" for="division">{{divisionsName}}</label>
                <label for="divisionsDropdown">{{ this.$root.getUser.settings.Labels.DivisionsName }} *</label>
                <ed-select @input="(o) => { addObjectUser.Division = o; this.divisionIncomplete = false; }"
                           :placeholder="`Select a ${singularize(this.$root.getUser.settings.Labels.DivisionName)}`"
                           :options="divisionsDropdown"
                           @open="getUserDivisions"
                           v-model="selectDivision"
                           label="DivisionName"
                           track-by="DivisionId"
                           :error="divisionIncomplete"
                           name="division_user" />
              </div>
              <div class="input-group-item-button col-md-6">
                <ed-button class="btn btn-actionbar"
                           @click="addSelectedDivisionToGrid">
                  Add
                </ed-button>
                <ed-button class="btn btn-actionbar"
                           @click="addAllDivisions">
                  Add All
                </ed-button>
                <ed-button class="btn btn-actionbar"
                           @click="removeAllDivisions">
                  Remove All
                </ed-button>
              </div>
            </div>
            <template>
              <div class="grid-container">
                <Grid class="divisions-list"
                      layout="frame"
                      :checkboxes="false"
                      :allowExport="false"
                      :model='DivisionModel.get(this.$root.getUser.settings)'
                      ref="grid"
                      :search="true"
                      :resizing="false"
                      :actions='actions'
                      :data='divisionsGrid'
                      :views="false"
                      :additional-filters="[]"
                      :all-row-selected="false"
                      :selected-rows="[]"
                      fit-columns
                      auto-height="auto-height"
                      @removeRow="(payload, success, fail) => handleRemoveDivision(payload, success, fail)"
                      :key="itemsHash(divisionsGrid)">
                </Grid>
              </div>
            </template>
            <br>
            <div class="row">
              <div v-if="this.$user.sessionSettings.CompanySettings.HasCostCenter && !this.$user.sessionSettings.CompanySettings.UseBusinessUnitAndCostCenterMapping" class="form-group col-md-6">
                <label for="costCenters">Cost Centers</label>
                <ed-select placeholder="Select a Cost Center"
                           :options="costCenters"
                           @open="getCostCenters"
                           v-model="selectCostCenter"
                           label="Value"
                           track-by="Key"
                           multiple
                           name="cost_center" />
              </div>
              <div v-if="this.$user.sessionSettings.CompanySettings.HasBusinessUnit && !this.$user.sessionSettings.CompanySettings.UseBusinessUnitAndCostCenterMapping" class="form-group col-md-6">
                <label for="businessUnit">Business Units</label>
                <ed-select placeholder="Select a Business Unit"
                           :options="businessUnit"
                           @open="getBusinessUnit"
                           v-model="selectBusinessUnit"
                           label="Value"
                           track-by="Key"
                           multiple
                           name="business_unit" />
              </div>
            </div>

            <div v-if="this.$user.sessionSettings.CompanySettings.UseBusinessUnitAndCostCenterMapping" class="form-group">
              <label for="businessUnitAndCostCenter">Business Units and Cost Centers</label>
              <ed-select placeholder="Select a Business Unit and Cost Center"
                         :options="businessUnitAndCostCenter"
                         @open="getBusinessUnitAndCostCenter"
                         v-model="selectBusinessUnitAndCostCenter"
                         label="Value"
                         track-by="Key"
                         multiple
                         name="BU_CC" />
            </div>
            <div class="form-group">
              <label for="name">First Name*</label>
              <ed-input @input="(o) => { user.FirstName = o; this.firstNameIncomplete = false; }"
                        type="text"
                        v-model="user.FirstName"
                        id="firstName"
                        :error="firstNameIncomplete"
                        placeholder="First Name"
                        class="full-width" />
            </div>
            <div class="form-group">
              <label for="name">Last Name*</label>
              <ed-input @input="(o) => { user.LastName = o; this.lastNameIncomplete = false; }"
                        type="text"
                        v-model="user.LastName"
                        id="lastName"
                        :error="lastNameIncomplete"
                        placeholder="Last Name"
                        class="full-width" />
            </div>
            <div class="form-group">
              <label for="title">Title</label>
              <ed-input @input="(o) => { user.Position = o; this.positionIncomplete = false; }"
                        type="text"
                        v-model="user.Position"
                        id="name"
                        :error="positionIncomplete"
                        placeholder="Title"
                        class="full-width" />
            </div>
            <div class="form-group">
              <label for="email">Email*</label>
              <ed-input @input="(o) => { user.Email = o; this.emailIncomplete = false; }"
                        type="text"
                        v-model="user.Email"
                        id="email"
                        :error="emailIncomplete"
                        placeholder="Email"
                        class="full-width" />
              <div v-if="emailError" class="error">{{ emailError }}</div>
            </div>
            <label for="name">Mobile Phone</label>
            <div class="row">
              <div class="col-md-3">
                <vue-country-code @onSelect="onCountrySelect"
                                  ref="countryCodeComponent"
                                  :disabledFetchingCountry="true"
                                  :enabledCountryCode="true"
                                  :preferredCountries="['us', 'gb', 'cn']"
                                  class="dropdown" />
              </div>
              <div class="col-md-9">
                <ed-input onlyNumbers
                          placeholder="222 333 1234"
                          v-model="user.MobilePhoneNumber"
                          :error="mobilePhoneIncomplete"
                          class="full-width">
                </ed-input>
              </div>
            </div>
            <div class="form-group">
              <label v-if="accountId === ''" for="countries">{{countriesName}}</label>
              <label for="role">Country</label>
              <ed-select @input="(o) => { addObjectUser.country  = o; this.countryIncomplete = false; }"
                         placeholder="Select a Country"
                         :options="countries"
                         :openEndpoint='api.$.profile.getAllCountries'
                         @select="countrySelected($event)"
                         @open="fetchCountriesOnOpen"
                         @keyup="fetchCountries"
                         v-model="formData.country"
                         label="CountryName"
                         track-by="CountryID"
                         :error="countryIncomplete"
                         :helptip-header="doDisplayCountryError && 'Error' || ''"
                         :helptip-body="doDisplayCountryError && 'Please select a country' || ''"
                         name="country_user" />
            </div>
            <p class="bold">Notification Preferences</p>
            <div class="form-group-checkbox">
              <input type="checkbox" id="turnOffEmailCheckbox" v-model="user.TurnOffEmail">
              <label class="small-checkbox" for="turnOffEmailCheckbox">Turn off all email communication</label>
            </div>
            <div class="form-group-checkbox">
              <input type="checkbox" id="copyRatingsCheckbox" v-model="user.ReceiveAllRatings" :disabled="user.TurnOffEmail">
              <label class="small-checkbox" for="copyRatingsCheckbox">Copy on all ratings received (receive all rating e-mails received from users)</label>
            </div>
            <div class="form-group-checkbox">
              <input type="checkbox" id="copyAdminEmailsCheckbox" v-model="user.ReceiveAllAdmin" :disabled="user.TurnOffEmail">
              <label class="small-checkbox" for="copyAdminEmailsCheckbox">Copy on all administration e-mails received (receive all e-mails currently being sent to the owner/administrator of this account)</label>
            </div>
          </div>
      </div>
      </ed-modal>
    </form>
</template>

<script>

import DivisionModel from './Divisions-list/DivisionModel'
import Grid from '@/components/Grid'
import {remove} from '@/components/Grid/cells/actions'

export default {
  components: {
    Grid
  },
  props: {
    show: Boolean
  },
  data: function () {
    return {
      DivisionModel,
      itemsHash: items => items.map(item => item.DivisionId).join('') + items.length,
      actions: [remove],
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: '',
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      roles: [],
      divisions: [],
      divisionsDropdown: [],
      costCenters: [],
      businessUnit: [],
      businessUnitAndCostCenter: [],
      selectCostCenter: [],
      deletedCostCenterIds: [],
      deletedBusinessUnitIds: [],
      deletedBuAndCcPair: [],
      selectBusinessUnit: [],
      selectBusinessUnitAndCostCenter: [],
      divisionsGrid: [],
      deletedDivisionIDs: [],
      countries: [],
      originalCountries: [],
      addObjectUser: {},
      selectRole: '',
      selectDivision: '',
      emailError: '',
      rolesLoaded: false,
      divisionsLoaded: false,
      costCenterLoaded: false,
      businessUnitLoaded: false,
      businessUnitAndCostCenterLoaded: false,
      roleIncomplete: false,
      divisionIncomplete: false,
      countryIncomplete: false,
      firstNameIncomplete: false,
      lastNameIncomplete: false,
      positionIncomplete: false,
      emailIncomplete: false,
      mobilePhoneIncomplete: false,
      user: {
        VendorUserID: 0,
        FirstName: '',
        LastName: '',
        Email: '',
        PhoneNumber: '',
        MobilePhoneNumber: '',
        MobilePhoneCode: '',
        MobileCountryCode: '',
        Position: '',
        RoleID: '',
        CountryID: '',
        TurnOffEmail: false,
        ReceiveAllRatings: false,
        ReceiveAllAdmin: false,
        VendorIdFromEOAdmin: 0
      }
    }
  },
  methods: {
    async addUser() {
      let valid = true

      if (!this.selectRole) {
        this.roleIncomplete = true
        valid = false
      } else {
        this.roleIncomplete = false
      }

      if (this.divisionsGrid.length === 0) {
        this.divisionIncomplete = true
        valid = false
      } else {
        this.divisionIncomplete = false
      }

      if (!this.user.FirstName) {
        this.firstNameIncomplete = true
        valid = false
      } else {
        this.firstNameIncomplete = false
      }

      if (!this.user.LastName) {
        this.lastNameIncomplete = true
        valid = false
      } else {
        this.lastNameIncomplete = false
      }

      if (!this.user.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user.Email)) {
        this.emailIncomplete = true
        valid = false
      } else {
        this.emailIncomplete = false
      }

      if (!valid) {
        return
      }

      const response = await this.api.forms.post(this.api.$.evedpaycard.saveUser, {
        user: JSON.stringify({
          ...this.user,
          CountryID: this.formData.country ? this.formData.country.CountryID : '',
          RoleID: this.selectRole.Id,
          DivisionId: this.selectDivision.DivisionId,
          costCenterId: this.selectCostCenter.Key,
          businessUnitId: this.selectBusinessUnit.Key
        }),
        newDivisionIDs: JSON.stringify(this.divisionsGrid.map(division => division.DivisionId + '')),
        deletedDivisionIDs: JSON.stringify(this.deletedDivisionIDs.map(deletedDivision => deletedDivision.Key + '')),
        costCenters: JSON.stringify(this.selectCostCenter.map(costCenter => costCenter.Key + '')),
        business: JSON.stringify(this.selectBusinessUnit.map(businessUnit => businessUnit.Key + '')),
        isFromEmail: false,
        isAllCC: 'false',
        buAndCcPairs: JSON.stringify(this.selectBusinessUnitAndCostCenter.map(buAndCcPairs => buAndCcPairs.Key + '')),
        deletedBuAndCcPair: JSON.stringify(this.deletedBuAndCcPair.map(deletedBuAndCcPair => deletedBuAndCcPair.Key + '')),
        deletedCostCenterIds: JSON.stringify(this.deletedCostCenterIds.map(deletedcostCenter => deletedcostCenter.Key + ''))
      })
      if (response && response.data) {
        if (response.data.SuccessMessage !== 'NotUnique') {
          this.showModalUser()
        } else {
          this.emailError = 'The e-mail address entered has already been used.'
          this.emailIncomplete = true
        }
      }
    },
    decodeHtml(html) {
      var txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },
    singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value
    },
    async getUserRoles() {
      if (!this.rolesLoaded) {
        try {
          const response = await this.api.get(this.api.$.approval.getRoles)
          const result = JSON.parse(response.data)

          result.sort((a, b) => a.Name.localeCompare(b.Name))

          for (const role of result) {
            this.roles.push({
              Id: role.Id,
              Name: role.Name
            })
          }

          this.rolesLoaded = true
          this.hasData = true
        } catch (error) {
          this.hasData = false
          console.warn('error', error)
        }
      }
    },
    async getCostCenters() {
      if (!this.costCentersLoaded) {
        try {
          const response = await this.api.post(this.api.$.evedpaycard.costCenters)
          if (response && response.data && Array.isArray(response.data.Data)) {
            this.costCenters = response.data.Data.map(item => ({
              ...item,
              Value: this.decodeHtml(item.Value)
            }))
          }
          this.costCentersLoaded = true
          this.hasData = true
        } catch (error) {
          console.warn('error', error)
          this.hasData = false
        }
      }
    },
    async getBusinessUnit() {
      if (!this.businessUnitLoaded) {
        try {
          const response = await this.api.post(this.api.$.evedpaycard.businessUnits)
          if (response && response.data) {
            this.businessUnit = response.data.Data.map(item => ({
              ...item,
              Value: this.decodeHtml(item.Value)
            }))
          }
          this.businessUnitLoaded = true
          this.hasData = true
        } catch (error) {
          console.warn('error', error)
          this.hasData = false
        }
      }
    },
    async getBusinessUnitAndCostCenter() {
      if (!this.businessUnitAndCostCenterLoaded) {
        try {
          const response = await this.api.post(this.api.$.evedpaycard.BU_CC_pair)

          if (response && response.data && Array.isArray(response.data.Data)) {
            this.businessUnitAndCostCenter = response.data.Data.map(item => ({
              ...item,
              Value: this.decodeHtml(item.Value)
            }))
          }

          this.businessUnitAndCostCenterLoaded = true
          this.hasData = true
        } catch (error) {
          console.warn('error', error)
          this.hasData = false
        }
      }
    },
    async fetchDivisions() {
      if (!this.divisionsLoaded) {
        try {
          const response = await this.api.get(this.api.$.evedpaycard.division)
          if (response && response.data) {
            this.divisions = response.data
            this.divisionsLoaded = true
          }
        } catch (error) {
          console.error('error', error)
        }
      }
    },

    async getUserDivisions() {
      await this.fetchDivisions()
      this.divisionsDropdown = this.divisions
    },

    removeAllDivisions() {
      this.divisionsGrid = []
    },

    async addAllDivisions() {
      await this.fetchDivisions()
      this.divisionsGrid = [...this.divisions]
      this.divisionIncomplete = false
    },
    addSelectedDivisionToGrid() {
      if (this.selectDivision) {
        const selectedDivision = this.divisionsDropdown.find(division => division.DivisionId === this.selectDivision.DivisionId)
        if (!this.divisionsGrid.find(division => division.DivisionId === selectedDivision.DivisionId)) {
          this.divisionsGrid.push(selectedDivision)
        } else {
          alert('This division is already added.')
        }
      } else {
        alert('Please select a division first.')
      }
    },
    handleRemoveDivision(payload, success, fail) {
      const divisionId = this.divisionsGrid[payload.index].DivisionId
      this.divisionsGrid.splice(+payload.index, 1)
      this.deletedDivisionIDs.push(divisionId)
      success()
    },
    countrySelected(e) {
      this.doDisplayCountryError = false
      this.resetState(e.CountryName)
    },
    resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        }
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        }
        this.formData.region = ''
      } else {
        this.originalCountryName = countryName
      }
    },
    fetchCountriesOnOpen() {
      if (this.countries.length) {
      } else {
        this.api.forms.post(
          this.api.$.profile.getAllCountries,
          {
            q: ''
          }
        ).then(r => {
          if (r && r.data && r.data.Data) {
            this.countries = r.data.Data
            this.originalCountries = r.data.Data
          }
        }
        ).catch(e => console.warn(e))
      }
    },
    showModalUser() {
      this.resetModalFields()
      this.$emit('close')
    },
    selectCostCenter(newValues, oldValues) {
      const newKeys = new Set(newValues.map(item => item.Key))
      const deletedItems = oldValues.filter(item => !newKeys.has(item.Key))
      const deletedIds = deletedItems.map(item => item.Key)
      this.deletedCostCenterIds.push(...deletedIds)

      this.deletedCostCenterIds = Array.from(new Set(this.deletedCostCenterIds))
    },
    selectBusinessUnit(newValues, oldValues) {
      const newKeys = new Set(newValues.map(item => item.Key))
      const deletedItems = oldValues.filter(item => !newKeys.has(item.Key))
      const deletedIds = deletedItems.map(item => item.Key)
      this.deletedBusinessUnitIds.push(...deletedIds)

      this.deletedBusinessUnitIds = Array.from(new Set(this.deletedBusinessUnitIds))
    },
    selectBusinessUnitAndCostCenter(newValues, oldValues) {
      const newKeys = new Set(newValues.map(item => item.Key))
      const deletedItems = oldValues.filter(item => !newKeys.has(item.Key))
      const deletedIds = deletedItems.map(item => item.Key)
      this.deletedBuAndCcPair.push(...deletedIds)

      this.deletedBuAndCcPair = Array.from(new Set(this.deletedBuAndCcPair))
    },
    onCountrySelect({ dialCode, iso2 }) {
      this.user.MobilePhoneCode = '+' + dialCode
      this.user.MobileCountryCode = iso2
    },
    resetModalFields() {
      this.$nextTick(() => {
        this.$refs.formRef.reset()
        this.formData = {
          city: '',
          postalCode: '',
          originalCountryName: '',
          country: '',
          state: { StateID: 0, StateName: '' },
          canadaState: { StateID: 0, StateName: '' },
          region: ''
        }
        this.user = {
          VendorUserID: 0,
          FirstName: '',
          LastName: '',
          Email: '',
          PhoneNumber: '',
          MobilePhone: '',
          Position: '',
          RoleID: '',
          CountryID: '',
          TurnOffEmail: false,
          ReceiveAllRatings: false,
          ReceiveAllAdmin: false,
          VendorIdFromEOAdmin: 0
        }
        this.selectRole = ''
        this.selectDivision = ''
        this.selectCostCenter = []
        this.selectBusinessUnit = []
        this.selectBusinessUnitAndCostCenter = []
        this.divisionsGrid = []
        this.deletedDivisionIDs = []
        this.emailError = false
        this.emailIncomplete = false
        this.firstNameIncomplete = false
        this.lastNameIncomplete = false
        this.divisionIncomplete = false
        this.roleIncomplete = false
      })
    }
  },
  watch: {
    turnOffEmailCheckbox (newVal) {
      if (newVal) {
        this.user.ReceiveAllRatings = false
        this.user.ReceiveAllAdmin = false
      }
    },
    show(newVal) {
      if (!newVal) {
        this.resetModalFields()
      }
    }
  }
}
</script>


<style lang="scss" scoped>

 .divisions-list {
  overflow: hidden;
  >>> .action-buttons {
    display: none;
  }
 }

 .grid-container {
  max-height: 500px;
  overflow: auto;
}
  .add-user-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .form-group {
    margin-bottom: 10px;
  }

  .form-group-checkbox {
    display: flex;
  }

  .small-checkbox{
    margin-left: 0.5rem;
    padding-top: 10px
  }

  .full-width {
    width: 100%;
  }

  .error {
    color: red;
  }

  .form-group label {
    vertical-align: middle;
  }

  .input-group {
    display: flex;
    flex-wrap: wrap;
  }

  .input-group-item-button {
    margin-right: 10px;
    margin-top: 20px;
  }

  .bold {
    font-size: medium;
    font-weight: bold;
  }

  ::-webkit-input-placeholder {
    font-size: 12px;
  }

  :-moz-placeholder {
    font-size: 12px;
  }

  ::-moz-placeholder {
    font-size: 12px;
  }

  :-ms-input-placeholder {
    font-size: 12px;
  }

  .dropdown {
    border-radius: unset;
    height: 34px;
    width:90px;
    ul.dropdown-list{
      width: 345px;
    }
  }
  div.vue-country-select:focus-within{
    box-shadow: 0px 0px 0px 1px #a9d85f;
    border-color: #a9d85f;
  }
  .dropdown >>> span.country-code{
    color: #333;
    font-weight: 400;
    font-size: 0.85rem;
    padding-left:8px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/AddUser.vue